export const STAGING_MODE_OPTIONS = [
  { value: 'NONE', label: 'No Staging', color: 'default', variant: 'outlined' },
  {
    value: 'POST_ONLY',
    label: 'POST Only',
    color: 'success',
    variant: 'filled',
  },
  { value: 'PUT_ONLY', label: 'PUT Only', color: 'info', variant: 'filled' },
  {
    value: 'POST_AND_PUT',
    label: 'POST & PUT',
    color: 'secondary',
    variant: 'filled',
  },
];

export const getStagingModeChipProps = (mode: string) =>
  STAGING_MODE_OPTIONS.find((o) => o.value === mode) || STAGING_MODE_OPTIONS[0];
